// 使用內存存儲照片（因為 File 對象不能序列化到 localStorage）
const photoStorage = new Map<string, File[]>();

/**
 * 保存產品服務照片
 * @param jobId Job ID
 * @param storeId Store ID
 * @param productId Product ID
 * @param photos 照片 File 數組
 * @param serviceCode 服務類型代碼（可選，例如 'inventory', 'cleaning' 等）
 * @param photoType 照片類型（可選，'before' 或 'after'）
 */
export const saveProductPhotos = (
  jobId: number, 
  storeId: number, 
  productId: number, 
  photos: File[],
  serviceCode?: string,
  photoType?: 'before' | 'after'
) => {
  let key = `photos_${jobId}_${storeId}_${productId}`;
  if (serviceCode) {
    key += `_${serviceCode}`;
  }
  if (photoType) {
    key += `_${photoType}`;
  }
  photoStorage.set(key, photos);
};

/**
 * 獲取產品服務照片
 * @param jobId Job ID
 * @param storeId Store ID
 * @param productId Product ID
 * @param serviceCode 服務類型代碼（可選）
 * @param photoType 照片類型（可選，'before' 或 'after'）
 * @returns 照片 File 數組
 */
export const getProductPhotos = (
  jobId: number, 
  storeId: number, 
  productId: number,
  serviceCode?: string,
  photoType?: 'before' | 'after'
): File[] => {
  let key = `photos_${jobId}_${storeId}_${productId}`;
  if (serviceCode) {
    key += `_${serviceCode}`;
  }
  if (photoType) {
    key += `_${photoType}`;
  }
  return photoStorage.get(key) || [];
};

/**
 * 清除整個店鋪的所有照片
 * @param jobId Job ID
 * @param storeId Store ID
 */
export const clearStorePhotos = (jobId: number, storeId: number) => {
  const keysToDelete: string[] = [];
  photoStorage.forEach((_, key) => {
    if (key.startsWith(`photos_${jobId}_${storeId}_`)) {
      keysToDelete.push(key);
    }
  });
  keysToDelete.forEach((key) => photoStorage.delete(key));
};

/**
 * 獲取整個店鋪的所有照片（用於提交）
 * @param jobId Job ID
 * @param storeId Store ID
 * @returns Map of keys to File arrays
 */
export const getAllStorePhotos = (jobId: number, storeId: number): Map<string, File[]> => {
  const result = new Map<string, File[]>();
  const prefix = `photos_${jobId}_${storeId}_`;
  
  photoStorage.forEach((files, key) => {
    if (key.startsWith(prefix)) {
      result.set(key, files);
    }
  });
  
  return result;
};

